(() => {
  if (window.__ztoveConfiguratorInit) return;
  window.__ztoveConfiguratorInit = true;

  const root = document.querySelector('[data-ztove-configurator]');
  if (!root) return;

  let products = [];
  let copy = {};
  try {
    products = JSON.parse(root.querySelector('[data-ztcfg-products]').textContent);
    copy = JSON.parse(root.querySelector('[data-ztcfg-copy]').textContent);
  } catch (e) {
    console.error('[ztcfg] Failed to parse data', e);
    return;
  }

  const moneyFormat = copy.money_format || '${{amount}}';

  const productByKey = {};
  const productByHandle = {};
  products.forEach((p) => {
    productByKey[p.key] = p;
    productByHandle[p.handle] = p;
  });

  const hobs = products.filter((p) => p.role === 'hob');
  const parts = products.filter((p) => p.role === 'part');
  const bundles = products.filter((p) => p.role === 'bundle');
  const cookware = products.filter((p) => p.role === 'cookware');

  const HOB_DOWNDRAFT_KEY = (() => {
    const dd = hobs.find((h) =>
      /downdraft/i.test(h.title) || /downdraft/i.test(h.handle)
    );
    return dd ? dd.key : null;
  })();

  const ICONS = {
    check:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 5 5L20 7"/></svg>',
    plus:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14"/><path d="M5 12h14"/></svg>',
    minus:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/></svg>',
    info:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 8h.01"/><path d="M11 12h1v4h1"/></svg>',
    edit:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 4H4v16h16v-7"/><path d="m18.5 2.5 3 3L12 15l-4 1 1-4z"/></svg>',
  };

  const STEPS = ['hob', 'venting', 'cookware', 'review'];
  const STEP_LABELS = { hob: 'Hob', venting: 'Venting', cookware: 'Cookware', review: 'Review' };

  const state = {
    step: 'hob',
    hob: null,
    venting: {
      mode: null, // 'recirculation' | 'external' | 'none'
      distance: '0-1',
      corners: 0,
      cornerType: 'connector_horizontal_90',
      parts: {}, // { partKey: qty }
    },
    cookware: {
      tab: 'bundles',
      bundle: null,
      items: {}, // { cookwareHandle: qty }
    },
    delivery: {
      mode: 'asap', // 'asap' | 'custom' | 'reserve'
      date: '', // ISO yyyy-mm-dd
    },
    submitting: false,
  };

  // ── Money formatting ─────────────────────────────────────────────────────
  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    // Lightweight fallback: ${{amount}} or {{amount}} kr style
    const value = (cents / 100).toFixed(2);
    return moneyFormat
      .replace(/{{\s*amount\s*}}/g, value)
      .replace(/{{\s*amount_no_decimals\s*}}/g, Math.round(cents / 100).toString())
      .replace(/{{\s*amount_with_comma_separator\s*}}/g, value.replace('.', ','));
  }

  // ── Step navigation ──────────────────────────────────────────────────────
  function setStep(step) {
    if (!STEPS.includes(step)) return;
    state.step = step;
    root.querySelectorAll('[data-step]').forEach((view) => {
      view.classList.toggle('is-active', view.dataset.step === step);
    });
    updateRail();
    if (step === 'venting') renderVenting();
    if (step === 'cookware') renderCookware();
    if (step === 'review') renderReview();
    updateTotals();
    // Reset internal scroll without affecting the page
    const stage = root.querySelector('[data-ztcfg-stage]');
    if (stage) stage.scrollTop = 0;
  }

  function nextStep() {
    if (!canProceed(state.step)) return;
    const idx = STEPS.indexOf(state.step);
    if (idx < STEPS.length - 1) setStep(STEPS[idx + 1]);
  }

  function prevStep() {
    const idx = STEPS.indexOf(state.step);
    if (idx > 0) setStep(STEPS[idx - 1]);
  }

  function canProceed(step) {
    if (step === 'hob') return !!state.hob;
    if (step === 'venting') {
      if (state.hob === HOB_DOWNDRAFT_KEY) return !!state.venting.mode;
      return true; // info-only for non-downdraft
    }
    if (step === 'cookware') return true; // always optional
    return false;
  }

  function updateRail() {
    const idx = STEPS.indexOf(state.step);
    root.querySelectorAll('[data-step-rail]').forEach((el) => {
      const elIdx = STEPS.indexOf(el.dataset.stepRail);
      el.classList.toggle('is-active', elIdx === idx);
      el.classList.toggle('is-done', elIdx < idx);
      el.classList.toggle('is-clickable', elIdx < idx);
    });
    const progress = root.querySelector('[data-ztcfg-progress]');
    if (progress) progress.style.width = `${((idx + 1) / STEPS.length) * 100}%`;

    // Back button enable/disable
    const backBtn = root.querySelector('[data-ztcfg-back]');
    if (backBtn) backBtn.disabled = idx === 0;

    // Step copy
    const mStep = root.querySelector('[data-ztcfg-mobile-step]');
    if (mStep) mStep.textContent = `Step ${idx + 1} · ${STEP_LABELS[state.step]}`;

    // Primary CTA — context aware label + enabled state
    const primary = root.querySelector('[data-ztcfg-primary]');
    const label = root.querySelector('[data-ztcfg-primary-label]');
    if (primary && label) {
      if (state.step === 'review') {
        label.textContent = (copy.cta && copy.cta.review_label) || 'Add everything to bag';
        primary.disabled = getCartItems().length === 0;
      } else if (state.step === 'cookware') {
        label.textContent = 'Review';
        primary.disabled = false;
      } else {
        label.textContent = 'Continue';
        primary.disabled = !canProceed(state.step);
      }
    }
  }

  // ── Totals ───────────────────────────────────────────────────────────────
  function getCartItems() {
    const items = [];
    if (state.hob) {
      const p = productByKey[state.hob];
      if (p) items.push({ id: p.variant_id, quantity: 1, _product: p, _section: 'Hob' });
    }
    if (state.hob === HOB_DOWNDRAFT_KEY) {
      if (state.venting.mode === 'recirculation') {
        const p = productByKey['recirculation_kit'];
        if (p) items.push({ id: p.variant_id, quantity: 1, _product: p, _section: 'Venting' });
      } else if (state.venting.mode === 'external') {
        Object.entries(state.venting.parts).forEach(([key, qty]) => {
          if (qty > 0) {
            const p = productByKey[key];
            if (p) items.push({ id: p.variant_id, quantity: qty, _product: p, _section: 'Venting' });
          }
        });
      }
    }
    if (state.cookware.tab === 'bundles' && state.cookware.bundle) {
      const p = productByKey[state.cookware.bundle];
      if (p) items.push({ id: p.variant_id, quantity: 1, _product: p, _section: 'Cookware' });
    } else if (state.cookware.tab === 'individual') {
      Object.entries(state.cookware.items).forEach(([handle, qty]) => {
        if (qty > 0) {
          const p = productByHandle[handle];
          if (p) items.push({ id: p.variant_id, quantity: qty, _product: p, _section: 'Cookware' });
        }
      });
    }
    return items;
  }

  function getSubtotal() {
    return getCartItems().reduce((sum, i) => sum + (i._product.price || 0) * i.quantity, 0);
  }

  function updateTotals() {
    const subtotal = getSubtotal();
    const formatted = subtotal > 0 ? formatMoney(subtotal) : '—';
    const a = root.querySelector('[data-ztcfg-total]');
    const b = root.querySelector('[data-ztcfg-mobile-total]');
    if (a) a.textContent = formatted;
    if (b) b.textContent = formatted;
  }

  // Derive a short badge from the hob title — e.g. "60 cm", "Downdraft 80 cm".
  function hobBadge(title) {
    const t = (title || '').toLowerCase();
    const dd = /downdraft/.test(t) ? 'Downdraft · ' : '';
    const m = t.match(/(\d{2,3})\s*cm/);
    const size = m ? `${m[1]} cm` : '';
    return (dd + size).trim() || '';
  }

  // ── Step 1: Hob ──────────────────────────────────────────────────────────
  function renderHob() {
    const grid = root.querySelector('[data-ztcfg-hob-grid]');
    if (!grid) return;
    if (!hobs.length) {
      grid.innerHTML = '<p class="ztcfg__review-empty">No hobs configured. Add hob products in the section settings.</p>';
      return;
    }
    const taglines = copy.hob_taglines || {};
    grid.innerHTML = hobs
      .map((p) => {
        const tag = taglines[p.handle] || taglines[p.key] || '';
        const badge = hobBadge(p.title);
        const isSelected = state.hob === p.key;
        return `
          <button type="button" class="ztcfg__card ${isSelected ? 'is-selected' : ''}" data-hob="${p.key}">
            ${badge ? `<span class="ztcfg__card-badge">${escapeHtml(badge)}</span>` : ''}
            <div class="ztcfg__card-image">
              ${p.featured_image ? `<img src="${p.featured_image}" alt="${escapeAttr(p.title)}" loading="lazy" />` : ''}
            </div>
            <div class="ztcfg__card-meta">
              <h3 class="ztcfg__card-title">${escapeHtml(p.title)}</h3>
              <p class="ztcfg__card-tag">${escapeHtml(tag)}</p>
            </div>
            <div class="ztcfg__card-foot">
              <span class="ztcfg__card-price">${formatMoney(p.price)}</span>
              <span class="ztcfg__card-select" aria-hidden="true">
                <span class="ztcfg__card-select-text">${isSelected ? 'Selected' : 'Select'}</span>
                ${ICONS.check}
              </span>
            </div>
          </button>`;
      })
      .join('');

    grid.querySelectorAll('[data-hob]').forEach((btn) => {
      btn.addEventListener('click', () => {
        state.hob = btn.dataset.hob;
        // Reset venting when hob changes
        state.venting.mode = null;
        state.venting.parts = {};
        renderHob();
        updateRail();
        updateTotals();
      });
    });
  }

  // ── Step 2: Venting ──────────────────────────────────────────────────────
  function isDowndraft() {
    return state.hob === HOB_DOWNDRAFT_KEY;
  }

  // Compute parts list for external venting based on distance + corners.
  // Always include the through-wall grille, exterior grille and one short
  // flexible duct that connects the hob fan to the rigid duct.
  function computeExternalParts() {
    const out = {};
    const add = (key, qty) => {
      if (productByKey[key] && qty > 0) out[key] = (out[key] || 0) + qty;
    };

    // Distance → number of 1m ducts and joiners.
    const distance = state.venting.distance;
    const distanceTable = {
      '0-1': { duct_1m: 1, duct_connector: 0 },
      '1-2': { duct_1m: 2, duct_connector: 1 },
      '2-3': { duct_1m: 3, duct_connector: 2 },
      '3-4': { duct_1m: 4, duct_connector: 3 },
    };
    const dist = distanceTable[distance] || distanceTable['0-1'];
    add('duct_1m', dist.duct_1m);
    add('duct_connector', dist.duct_connector);

    // Corners → 90° connectors of chosen type
    add(state.venting.cornerType, state.venting.corners);

    // Standard endpoints
    add('flexible_duct_024', 1);
    add('trough_wall_grille', 1);
    add('exterior_grille', 1);

    return out;
  }

  function renderVenting() {
    const wrap = root.querySelector('[data-ztcfg-vent]');
    const titleEl = root.querySelector('[data-ztcfg-vent-title]');
    const subEl = root.querySelector('[data-ztcfg-vent-sub]');
    if (!wrap) return;

    const v = copy.venting || {};
    if (!isDowndraft()) {
      titleEl.textContent = v.heading_std || 'No extra venting needed';
      subEl.textContent = v.sub_std || 'Your selected hob works with any standard range hood. If you already have one above your cooktop, you’re ready to go.';
      wrap.innerHTML = `
        <div class="ztcfg__vent-info">
          <div class="ztcfg__vent-info-icon">${ICONS.info}</div>
          <div class="ztcfg__vent-info-body">
            <h3>${escapeHtml(v.info_title || 'Use your existing range hood')}</h3>
            <p>${escapeHtml(v.info_body || 'This hob installs flush in any standard induction cut-out and pairs with a wall- or ceiling-mounted range hood. Continue to add cookware.')}</p>
          </div>
        </div>`;
      return;
    }

    titleEl.textContent = v.heading_dd || 'Set up venting';
    subEl.textContent = v.sub_dd || 'The downdraft hob pulls cooking fumes down into the worktop. Choose how the air leaves your kitchen.';

    const mode = state.venting.mode;
    const recKit = productByKey['recirculation_kit'];
    const externalApprox =
      Object.entries(computeExternalParts()).reduce((s, [k, q]) => {
        const p = productByKey[k];
        return p ? s + (p.price || 0) * q : s;
      }, 0);

    const recCopy = v.recirc || {};
    const extCopy = v.external || {};
    wrap.innerHTML = `
      <div class="ztcfg__vent-modes">
        <button type="button" class="ztcfg__mode ${mode === 'recirculation' ? 'is-selected' : ''}" data-mode="recirculation">
          <span class="ztcfg__mode-eyebrow">${escapeHtml(recCopy.eyebrow || 'Recirculation')}</span>
          <h3 class="ztcfg__mode-title">${escapeHtml(recCopy.title || 'Filter and re-emit air')}</h3>
          <p class="ztcfg__mode-desc">${escapeHtml(recCopy.desc || 'Best for apartments and retrofits. No exterior wall needed. Filters smoke and grease, then returns clean air to the kitchen.')}</p>
          <div class="ztcfg__mode-foot">
            <span>${escapeHtml(recCopy.foot || '1 kit, no ducts')}</span>
            <strong>${recKit ? formatMoney(recKit.price) : '—'}</strong>
          </div>
        </button>
        <button type="button" class="ztcfg__mode ${mode === 'external' ? 'is-selected' : ''}" data-mode="external">
          <span class="ztcfg__mode-eyebrow">${escapeHtml(extCopy.eyebrow || 'External venting')}</span>
          <h3 class="ztcfg__mode-title">${escapeHtml(extCopy.title || 'Vent outside')}</h3>
          <p class="ztcfg__mode-desc">${escapeHtml(extCopy.desc || 'Pulls air through a duct to an exterior wall. Maximum performance and zero recirculated humidity in the kitchen.')}</p>
          <div class="ztcfg__mode-foot">
            <span>${escapeHtml(extCopy.foot || 'From')}</span>
            <strong>${formatMoney(externalApprox)}</strong>
          </div>
        </button>
      </div>
      ${mode === 'external' ? renderExternalParams() : ''}`;

    wrap.querySelectorAll('[data-mode]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const m = btn.dataset.mode;
        state.venting.mode = m;
        if (m === 'recirculation') {
          state.venting.parts = {};
        } else if (m === 'external') {
          state.venting.parts = computeExternalParts();
        }
        renderVenting();
        updateRail();
        updateTotals();
      });
    });

    if (mode === 'external') {
      bindExternalParams(wrap);
    }
  }

  function renderExternalParams() {
    const distances = [
      { key: '0-1', label: '0–1 m' },
      { key: '1-2', label: '1–2 m' },
      { key: '2-3', label: '2–3 m' },
      { key: '3-4', label: '3 m+' },
    ];
    const cornerOpts = [0, 1, 2, 3];

    const partsList = Object.entries(state.venting.parts)
      .map(([key, qty]) => {
        const p = productByKey[key];
        if (!p) return '';
        return `
          <div class="ztcfg__part" data-part-key="${key}">
            <div class="ztcfg__part-thumb">${p.featured_image_thumb ? `<img src="${p.featured_image_thumb}" alt="" loading="lazy" />` : ''}</div>
            <div class="ztcfg__part-meta">
              <p class="ztcfg__part-title">${escapeHtml(p.title)}</p>
              <p class="ztcfg__part-price">${formatMoney(p.price)} · ${formatMoney(p.price * qty)} total</p>
            </div>
            <div class="ztcfg__qty">
              <button type="button" data-qty-dec aria-label="Decrease">${ICONS.minus}</button>
              <span class="ztcfg__qty-val">${qty}</span>
              <button type="button" data-qty-inc aria-label="Increase">${ICONS.plus}</button>
            </div>
          </div>`;
      })
      .join('');

    const partsTotal = Object.entries(state.venting.parts).reduce((s, [k, q]) => {
      const p = productByKey[k];
      return p ? s + (p.price || 0) * q : s;
    }, 0);

    return `
      <div class="ztcfg__vent-params">
        <div>
          <h4 class="ztcfg__param-label">Distance to exterior wall</h4>
          <p class="ztcfg__param-help">Approximate run length from the hob to the outside vent.</p>
          <div class="ztcfg__seg" data-seg="distance">
            ${distances
              .map(
                (d) =>
                  `<button type="button" data-seg-val="${d.key}" class="${state.venting.distance === d.key ? 'is-active' : ''}">${d.label}</button>`
              )
              .join('')}
          </div>
        </div>
        <div>
          <h4 class="ztcfg__param-label">90° corners on the route</h4>
          <p class="ztcfg__param-help">Each corner adds one elbow connector.</p>
          <div class="ztcfg__seg" data-seg="corners">
            ${cornerOpts
              .map(
                (c) =>
                  `<button type="button" data-seg-val="${c}" class="${state.venting.corners === c ? 'is-active' : ''}">${c}</button>`
              )
              .join('')}
          </div>
        </div>
      </div>

      <div class="ztcfg__parts">
        <div class="ztcfg__parts-head">
          <h3>Your venting kit</h3>
          <span class="ztcfg__parts-total">${formatMoney(partsTotal)}</span>
        </div>
        ${partsList || '<div class="ztcfg__part"><p class="ztcfg__review-empty">No parts configured.</p></div>'}
      </div>`;
  }

  function bindExternalParams(wrap) {
    wrap.querySelectorAll('[data-seg]').forEach((seg) => {
      seg.querySelectorAll('[data-seg-val]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const segName = seg.dataset.seg;
          const val = btn.dataset.segVal;
          if (segName === 'distance') state.venting.distance = val;
          if (segName === 'corners') state.venting.corners = parseInt(val, 10);
          state.venting.parts = computeExternalParts();
          renderVenting();
          updateTotals();
        });
      });
    });

    wrap.querySelectorAll('[data-part-key]').forEach((row) => {
      const key = row.dataset.partKey;
      row.querySelector('[data-qty-inc]').addEventListener('click', () => {
        state.venting.parts[key] = (state.venting.parts[key] || 0) + 1;
        renderVenting();
        updateTotals();
      });
      row.querySelector('[data-qty-dec]').addEventListener('click', () => {
        state.venting.parts[key] = Math.max(0, (state.venting.parts[key] || 0) - 1);
        if (state.venting.parts[key] === 0) delete state.venting.parts[key];
        renderVenting();
        updateTotals();
      });
    });
  }

  // ── Step 3: Cookware ─────────────────────────────────────────────────────
  function renderCookware() {
    const wrap = root.querySelector('[data-ztcfg-cookware]');
    if (!wrap) return;

    // Sync tab UI
    root.querySelectorAll('[data-cw-tab]').forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.cwTab === state.cookware.tab);
    });

    if (state.cookware.tab === 'bundles') {
      if (!bundles.length) {
        wrap.innerHTML = '<p class="ztcfg__review-empty">No bundles configured.</p>';
        return;
      }
      wrap.innerHTML = `
        <div class="ztcfg__bundles">
          ${bundles
            .map((b) => {
              const selected = state.cookware.bundle === b.key;
              return `
            <button type="button" class="ztcfg__card ztcfg__bundle ${selected ? 'is-selected' : ''}" data-bundle="${b.key}">
              <div class="ztcfg__card-image">
                ${b.featured_image ? `<img src="${b.featured_image}" alt="${escapeAttr(b.title)}" loading="lazy" />` : ''}
              </div>
              <div class="ztcfg__card-meta">
                <h3 class="ztcfg__card-title">${escapeHtml(b.title)}</h3>
                <p class="ztcfg__card-tag">${escapeHtml(b.description_text || '')}</p>
              </div>
              <div class="ztcfg__card-foot">
                <span class="ztcfg__card-price">${formatMoney(b.price)}</span>
                <span class="ztcfg__card-select" aria-hidden="true">
                  <span class="ztcfg__card-select-text">${selected ? 'Selected' : 'Select'}</span>
                  ${ICONS.check}
                </span>
              </div>
            </button>`;
            })
            .join('')}
        </div>`;

      wrap.querySelectorAll('[data-bundle]').forEach((btn) => {
        btn.addEventListener('click', () => {
          state.cookware.bundle = state.cookware.bundle === btn.dataset.bundle ? null : btn.dataset.bundle;
          renderCookware();
          updateTotals();
        });
      });
    } else if (state.cookware.tab === 'individual') {
      if (!cookware.length) {
        wrap.innerHTML = '<p class="ztcfg__review-empty">No cookware collection configured.</p>';
        return;
      }
      wrap.innerHTML = `
        <div class="ztcfg__cw-grid">
          ${cookware
            .map((p) => {
              const qty = state.cookware.items[p.handle] || 0;
              return `
            <button type="button" class="ztcfg__cw-card ${qty > 0 ? 'is-selected' : ''}" data-cw="${p.handle}">
              <span class="ztcfg__cw-card-add" aria-hidden="true">${qty > 0 ? ICONS.check : ICONS.plus}</span>
              <div class="ztcfg__card-image">
                ${p.featured_image_thumb ? `<img src="${p.featured_image_thumb}" alt="${escapeAttr(p.title)}" loading="lazy" />` : ''}
              </div>
              <h3 class="ztcfg__cw-card-title">${escapeHtml(p.title)}</h3>
              <span class="ztcfg__cw-card-price">${formatMoney(p.price)}${qty > 1 ? ` · ×${qty}` : ''}</span>
            </button>`;
            })
            .join('')}
        </div>`;

      wrap.querySelectorAll('[data-cw]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const handle = btn.dataset.cw;
          state.cookware.items[handle] = (state.cookware.items[handle] || 0) + 1;
          // Cap at 3 then reset to 0
          if (state.cookware.items[handle] > 3) state.cookware.items[handle] = 0;
          if (state.cookware.items[handle] === 0) delete state.cookware.items[handle];
          renderCookware();
          updateTotals();
        });
      });
    } else if (state.cookware.tab === 'skip') {
      state.cookware.bundle = null;
      state.cookware.items = {};
      const cw = copy.cookware || {};
      wrap.innerHTML = `
        <div class="ztcfg__skip">
          <h3>${escapeHtml(cw.skip_title || 'You can skip cookware')}</h3>
          <p>${escapeHtml(cw.skip_body || 'Your hob works with any induction cookware you already own. You won’t get TrueTemp™ precision until you add Ztove cookware — but you can always add it later.')}</p>
        </div>`;
      updateTotals();
    }
  }

  // ── Step 4: Review ───────────────────────────────────────────────────────
  function minDeliveryDate() {
    const d = new Date();
    d.setDate(d.getDate() + 3);
    return d.toISOString().slice(0, 10);
  }

  function renderReview() {
    const wrap = root.querySelector('[data-ztcfg-review]');
    if (!wrap) return;

    const items = getCartItems();
    if (!items.length) {
      wrap.innerHTML = '<div class="ztcfg__review-section"><p class="ztcfg__review-empty">Nothing selected yet. Go back and pick a hob.</p></div>';
      updateTotals();
      return;
    }

    const grouped = items.reduce((acc, i) => {
      acc[i._section] = acc[i._section] || [];
      acc[i._section].push(i);
      return acc;
    }, {});

    const sectionToStep = { Hob: 'hob', Venting: 'venting', Cookware: 'cookware' };

    const sectionHtml = Object.entries(grouped)
      .map(([section, lines]) => {
        return `
          <div class="ztcfg__review-section">
            <div class="ztcfg__review-section-head">
              <h3>${section}</h3>
              <button type="button" class="ztcfg__review-edit" data-edit-step="${sectionToStep[section]}">Edit</button>
            </div>
            ${lines
              .map((line) => {
                const p = line._product;
                return `
                  <div class="ztcfg__review-line">
                    <div class="ztcfg__part-thumb">${p.featured_image_thumb ? `<img src="${p.featured_image_thumb}" alt="" loading="lazy" />` : ''}</div>
                    <div class="ztcfg__review-line-meta">
                      <p class="ztcfg__review-line-title">${escapeHtml(p.title)}</p>
                      <p class="ztcfg__review-line-sub">${formatMoney(p.price)} · Qty ${line.quantity}</p>
                    </div>
                    <span class="ztcfg__review-line-price">${formatMoney(p.price * line.quantity)}</span>
                  </div>`;
              })
              .join('')}
          </div>`;
      })
      .join('');

    if (state.delivery.mode === 'custom' && !state.delivery.date) {
      state.delivery.date = minDeliveryDate();
    }

    const dl = copy.delivery || {};
    const deliveryHtml = `
      <div class="ztcfg__review-section">
        <div class="ztcfg__review-section-head">
          <h3>Delivery</h3>
        </div>
        <div class="ztcfg__delivery-options" role="radiogroup">
          <button type="button" class="ztcfg__delivery-opt ${state.delivery.mode === 'asap' ? 'is-active' : ''}" data-delivery="asap" role="radio" aria-checked="${state.delivery.mode === 'asap'}">
            <span class="ztcfg__delivery-opt-title">${escapeHtml(dl.asap_label || 'As soon as possible')}</span>
            <span class="ztcfg__delivery-opt-desc">${escapeHtml(dl.asap_desc || 'Ships within 1–2 business days.')}</span>
          </button>
          <button type="button" class="ztcfg__delivery-opt ${state.delivery.mode === 'custom' ? 'is-active' : ''}" data-delivery="custom" role="radio" aria-checked="${state.delivery.mode === 'custom'}">
            <span class="ztcfg__delivery-opt-title">${escapeHtml(dl.custom_label || 'Pick a delivery date')}</span>
            <span class="ztcfg__delivery-opt-desc">${escapeHtml(dl.custom_desc || 'We’ll deliver on your chosen day.')}</span>
          </button>
          <button type="button" class="ztcfg__delivery-opt ${state.delivery.mode === 'reserve' ? 'is-active' : ''}" data-delivery="reserve" role="radio" aria-checked="${state.delivery.mode === 'reserve'}">
            <span class="ztcfg__delivery-opt-title">${escapeHtml(dl.reserve_label || 'Reserve')}</span>
            <span class="ztcfg__delivery-opt-desc">${escapeHtml(dl.reserve_desc || 'We’ll reach out to schedule when you’re ready.')}</span>
          </button>
        </div>
        ${
          state.delivery.mode === 'custom'
            ? `<div class="ztcfg__delivery-date">
                <label for="ztcfg-date" class="ztcfg__delivery-date-label">Choose your delivery date</label>
                <input id="ztcfg-date" type="date" class="ztcfg__delivery-date-input" min="${minDeliveryDate()}" value="${state.delivery.date}" />
              </div>`
            : ''
        }
      </div>`;

    const subtotal = getSubtotal();
    wrap.innerHTML = `
      ${sectionHtml}
      ${deliveryHtml}
      <div class="ztcfg__review-totals">
        <div class="ztcfg__review-row ztcfg__review-row--total">
          <span>Subtotal</span>
          <span>${formatMoney(subtotal)}</span>
        </div>
        <p class="ztcfg__review-shipping">${escapeHtml(copy.shipping_note || '')}</p>
      </div>`;

    wrap.querySelectorAll('[data-edit-step]').forEach((btn) => {
      btn.addEventListener('click', () => setStep(btn.dataset.editStep));
    });
    wrap.querySelectorAll('[data-delivery]').forEach((btn) => {
      btn.addEventListener('click', () => {
        state.delivery.mode = btn.dataset.delivery;
        renderReview();
      });
    });
    const dateInput = wrap.querySelector('#ztcfg-date');
    if (dateInput) {
      dateInput.addEventListener('change', (e) => {
        state.delivery.date = e.target.value;
      });
    }
  }

  // ── Add all to cart ──────────────────────────────────────────────────────
  async function addAllToCart() {
    if (state.submitting) return;
    const items = getCartItems()
      .filter((i) => i.id)
      .map((i) => ({ id: i.id, quantity: i.quantity }));
    if (!items.length) return;

    const btn = root.querySelector('[data-ztcfg-primary]');
    const label = root.querySelector('[data-ztcfg-primary-label]');
    btn.classList.add('is-loading');
    state.submitting = true;
    try {
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!addRes.ok) {
        const errorText = await addRes.text();
        throw new Error(errorText || 'Failed to add to cart');
      }

      // Persist delivery choice as cart attributes so checkout/admin can read it
      const attributes = {
        'Delivery option':
          state.delivery.mode === 'asap'
            ? 'As soon as possible'
            : state.delivery.mode === 'custom'
              ? 'Custom date'
              : 'Reserve',
      };
      if (state.delivery.mode === 'custom' && state.delivery.date) {
        attributes['Delivery date'] = state.delivery.date;
      }
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes }),
      });

      window.location.href = '/cart';
    } catch (err) {
      console.error('[ztcfg] add to cart failed', err);
      label.textContent = (copy.cta && copy.cta.review_error) || 'Could not add — try again';
      btn.classList.remove('is-loading');
      state.submitting = false;
      setTimeout(() => {
        label.textContent = (copy.cta && copy.cta.review_label) || 'Add everything to bag';
      }, 3500);
    }
  }

  // ── Misc ─────────────────────────────────────────────────────────────────
  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function escapeAttr(str) {
    return escapeHtml(str);
  }

  // ── Wire up ──────────────────────────────────────────────────────────────
  const primaryBtn = root.querySelector('[data-ztcfg-primary]');
  if (primaryBtn) {
    primaryBtn.addEventListener('click', () => {
      if (state.step === 'review') addAllToCart();
      else nextStep();
    });
  }
  root.querySelectorAll('[data-ztcfg-back]').forEach((btn) => {
    btn.addEventListener('click', prevStep);
  });
  root.querySelectorAll('[data-cw-tab]').forEach((btn) => {
    btn.addEventListener('click', () => {
      state.cookware.tab = btn.dataset.cwTab;
      renderCookware();
      updateTotals();
    });
  });
  root.querySelectorAll('[data-step-rail]').forEach((el) => {
    el.addEventListener('click', () => {
      if (el.classList.contains('is-clickable')) setStep(el.dataset.stepRail);
    });
  });

  // Initial render
  renderHob();
  updateRail();
  updateTotals();
})();
